






































import {Vue, Component, Watch} from 'vue-property-decorator';

import MallsTab from '@/components/common/MallsTab.vue';
import SequenceList from '@/components/board/common/SequenceList.vue';
import BoardDetail from '@/components/board/BoardDetail.vue';

import {State, namespace} from 'vuex-class';
const mallModule = namespace('mall');

import {
  Mall,
  GetBoardsRequest,
  GetBoards,
  BoardCategoryResponse,
  CategoriesName,
  GetBoardsDetailRequest,
  BoardsDetail,
  PostBoardsRequest,
  DeleteBoardsRequest,
  GetBoardsPostsCountRequest,
  PutBoardsRequest
} from 'supporter';

@Component({
  name: 'Boards',
  components: {MallsTab, SequenceList, BoardDetail}
})
export default class Boards extends Vue {
  @mallModule.Action('fetchMalls') fetchMalls!: () => Promise<any>;
  @State('malls', {namespace: 'mall'})
  private malls!: Mall[];
  private mallNo: number = 0;
  private isOrder = false;
  private hasBoard = false;
  private boardIndex: number = 0;
  private boards: GetBoards[] = [];
  private origBoardDetail!: BoardsDetail;
  private tmpBoardDetail: any = {
    replyUsed: false,
    categoryUsed: false,
    thumbnailUsed: false,
    boardDescription: '',
    guestPostingUsed: false,
    secretPostingUsed: false,
    memberPostingUsed: false,
    categories: [],
    boardName: '',
    boardNo: -1,
    boardId: '',
    used: false,
    attachmentUsed: false,
  };


  @Watch('$route.query.mallNo', {immediate: false, deep: false})
  async onMallChange() {
    if (this.$route.query.mallNo) {
      this.mallNo = Number(this.$route.query.mallNo);
    } else {
      this.mallNo = this.malls[0].mallNo;
    }
      await this.doChangeMall();
  }

  private onItemSelect(index: number): void {
    this.boardIndex = index;
    if (this.boardIndex >= 0) {
      if (this.boards[this.boardIndex].boardNo > 0) {
        // this.refreshGradeDetail(this.boardIndex);
        this.tmpBoardDetail = this.boards[this.boardIndex];
      } else {
        this.tmpBoardDetail = {
          replyUsed: false,
          categoryUsed: false,
          thumbnailUsed: false,
          boardDescription: '',
          guestPostingUsed: false,
          secretPostingUsed: false,
          memberPostingUsed: false,
          categories: [],
          boardName: '',
          boardNo: -1,
          boardId: '',
          used: false
        };
      }
    }
  }

  private onDetailNameChange(nameInfo: any) {
    if (nameInfo.type === 'list') {
      this.tmpBoardDetail.boardName = nameInfo.name;
    } else {
      if (this.boardIndex === -1) {
        this.boards[0].boardName = nameInfo.name;
      } else {
        this.boards[this.boardIndex].boardName = nameInfo.name;
      }
    }
  }

  private doSetting(): void {
    // if (this.isDetailModified()) {
    if (this.tmpBoardDetail.boardName === '') {
      alert(this.$t('BOARD_BOARD_ERR_BOARD_NAME_NULL'));
    } else if (this.tmpBoardDetail.categoryUsed === true && this.tmpBoardDetail.categories.length > 0 && this.tmpBoardDetail.categories[0].categoryName.length == 0) {
      alert(this.$t('BOARD_BOARD_ERR_BOARD_CATEGORY_NAME_NULL'));
    } else {
      if (confirm('' + this.$t('BOARD_BOARD_COMFIRM_BEFORE_MODIFY'))) {
        if (this.tmpBoardDetail.boardNo === -1) {
          this.doAddBoard();
        } else {
          this.doModifyBoardDetail();
        }
      }
    }
    // }
  }

  private onAddFirstCategory(used: boolean): void {
    if(used){
      alert(this.$t('BOARD_BOARD_WARN_BOARD_MOVE_ARTICLES'));
    }
    if (this.tmpBoardDetail.categories.length === 0) {
      this.onAddCategory();
    }
  }

  private onAddCategory(): void {
    const cateNew: BoardCategoryResponse = {
      categoryName: '',
      categoryNo: -1
    };
    this.tmpBoardDetail.categories.push(cateNew);
  }

  private onDeleteCategory(index: number): void {
    if(confirm('' + this.$t('BOARD_BOARD_CONFIRM_DELETE_CATEGORY'))){
      const cateNoDel = this.tmpBoardDetail.categories[index].categoryNo;
      if(cateNoDel && cateNoDel>0){
        const cateDel: GetBoardsPostsCountRequest = {
          pathParams: {
            boardNo: this.tmpBoardDetail.boardNo
          },
          params: {
            mallNo: this.mallNo,
            categoryNo: cateNoDel
          }
        };
      this.$api.getBoardsPostsCount(cateDel).then((ret): void => {
        if(ret.data.count > 0){
          alert(this.$t('BOARD_BOARD_CANCEL_DELETE_CATEGORY'));
        }else{
          this.tmpBoardDetail.categories.splice(index, 1);
        }
      });
      }else{
        this.tmpBoardDetail.categories.splice(index, 1);
      }

    }

  }

  private onADD(): void {
    const boardNew: any = {
      replyUsed: false,
      categoryUsed: false,
      thumbnailUsed: false,
      boardDescription: '',
      guestPostingUsed: false,
      secretPostingUsed: false,
      memberPostingUsed: false,
      categories: [],
      boardName: this.$t('BOARD_BOARD_BOARD_NAME_PLACEHOLDER').toString(),
      boardNo: -1
    };
    this.boards.push(boardNew);
    this.hasBoard = true;
    this.boardIndex = this.boards.length - 1;
    this.onItemSelect(this.boardIndex);
  }

  private onDelete(): void {
    if (this.boards && this.boards.length > 0 && this.boardIndex >= 0 && this.boardIndex < this.boards.length) {
      if (this.boards[this.boardIndex].boardNo > 0) {
        if (this.boards[this.boardIndex].categories.length > 0) {
          alert(this.$t('BOARD_BOARD_ERR_DELETE_BOARD_WITH_CUSTOMER'));
        } else {
          if (confirm('' + this.$t('BOARD_BOARD_COMFIRM_BEFORE_DELETE_BOARD'))) {
            this.doDeleteBoard(this.boardIndex);
          }
        }
      } else {
        if (confirm('' + this.$t('BOARD_BOARD_COMFIRM_BEFORE_DELETE_BOARD'))) {
          this.boards.splice(this.boardIndex, 1);
          this.boardIndex = this.boards.length > 0 ? 0 : -1;
          if (this.boardIndex >= 0) {
            this.refreshGradeDetail(0);
          }
        }
      }
      if(this.boards.length == 0){
        this.hasBoard = false;
      }
    }else{
      alert(this.$t('BOARD_BOARD_ERR_NOT_FOUND_BOARD'));
    }
  }
  private onOrderUp(index: number): void {
    if (index > 0) {
      if (this.boards[index].boardNo > 0) {
        // order 변경 시 sequence를 0부터가 아닌 1부터 수정하도록 변경
        this.doChangeBoardOrder(index, +1);
      }
    }
  }
  private onOrderDown(index: number): void {
    if (index < this.boards.length - 1) {
      if (this.boards[index].boardNo > 0) {
        // order 변경 시 sequence를 0부터가 아닌 1부터 수정하도록 변경
        this.doChangeBoardOrder(index, -1);
      }
    }
  }

  private isDetailModified(): boolean {
    // categoriey内容判断
    let categoriey = false;
    if (this.tmpBoardDetail.categoryUsed) {
      this.tmpBoardDetail.categories.forEach((item1: BoardCategoryResponse) => {
        this.origBoardDetail.categories.forEach((item2: BoardCategoryResponse) => {
          if (item1.categoryNo === item2.categoryNo && item1.categoryName === item2.categoryName) {
            categoriey = false;
            return;
          } else {
            categoriey = true;
          }
        });
      });
    }

    return (
      this.tmpBoardDetail.boardNo !== this.origBoardDetail.boardNo ||
      this.tmpBoardDetail.boardName !== this.origBoardDetail.boardName ||
      this.tmpBoardDetail.boardDescription !== this.origBoardDetail.boardDescription ||
      Boolean(this.tmpBoardDetail.replyUsed) !== Boolean(this.origBoardDetail.replyUsed) ||
      Boolean(this.tmpBoardDetail.categoryUsed) !== Boolean(this.origBoardDetail.categoryUsed) ||
      Boolean(this.tmpBoardDetail.thumbnailUsed) !== Boolean(this.origBoardDetail.thumbnailUsed) ||
      Boolean(this.tmpBoardDetail.guestPostingUsed) !== Boolean(this.origBoardDetail.guestPostingUsed) ||
      Boolean(this.tmpBoardDetail.secretPostingUsed) !== Boolean(this.origBoardDetail.secretPostingUsed) ||
      Boolean(this.tmpBoardDetail.memberPostingUsed) !== Boolean(this.origBoardDetail.memberPostingUsed) ||
      categoriey
    );
  }

  private async doChangeMall() {
    const request: GetBoardsRequest = {
      params: {
        mallNo: this.mallNo
      }
    };
    this.$api.getBoards(request).then((ret): void => {
      this.boards = ret.data;
      this.boards.every(board =>
        // console.log(jQuery.parseHTML(board.boardName)[0].textContent)
        board.boardName = jQuery.parseHTML(board.boardName)[0].textContent
      )

      if (this.boards.length > 0) {
        this.boards.reverse();
        this.hasBoard = true;
      }else{
        this.hasBoard = false;
      }
      if (!this.isOrder) {
        this.boardIndex = this.boards && this.boards.length ? 0 : -1;
      }
      this.onItemSelect(this.boardIndex);
      this.isOrder = false;
    });
  }

  private refreshGradeDetail(index: number): void {
    const request: GetBoardsDetailRequest = {
      params: {
        boardNo: this.boards[index].boardNo.toString(),
        mallNo: this.mallNo
      }
    };
    this.$api.getBoardsDetail(request).then((ret): void => {
      ret.data.boardName = jQuery.parseHTML(ret.data.boardName)[0].textContent;
      if(ret.data.boardDescription && ret.data.boardDescription.length>0){
        ret.data.boardDescription = jQuery.parseHTML(ret.data.boardDescription)[0].textContent;
      }
      
      this.origBoardDetail = ret.data;
      this.initDetail(ret.data);
      this.tmpBoardDetail = ret.data;
    });
  }

  private initDetail(detail: BoardsDetail): void {
    this.origBoardDetail = Object.create(null);
    this.origBoardDetail.replyUsed = detail.replyUsed;
    this.origBoardDetail.categoryUsed = detail.categoryUsed;
    this.origBoardDetail.thumbnailUsed = detail.thumbnailUsed;
    this.origBoardDetail.boardDescription = detail.boardDescription;
    this.origBoardDetail.guestPostingUsed = detail.guestPostingUsed;
    this.origBoardDetail.secretPostingUsed = detail.secretPostingUsed;
    this.origBoardDetail.memberPostingUsed = detail.memberPostingUsed;
    this.origBoardDetail.boardName = detail.boardName;
    this.origBoardDetail.categories = [];
    detail.categories.forEach((categorie: BoardCategoryResponse, index: number) => {
      this.origBoardDetail.categories[index] = categorie;
    });
    this.origBoardDetail.boardNo = detail.boardNo;
  }

  private doAddBoard(): void {
    const request: PostBoardsRequest = {
      data: {
        mallNo: this.mallNo,
        name: this.tmpBoardDetail.boardName.toString(),
        description: this.tmpBoardDetail.boardDescription?.toString(),
        replyUsed: Boolean(this.tmpBoardDetail.replyUsed),
        categoryUsed: Boolean(this.tmpBoardDetail.categoryUsed),
        thumbnailUsed: Boolean(this.tmpBoardDetail.thumbnailUsed),
        guestPostingUsed: Boolean(this.tmpBoardDetail.guestPostingUsed),
        secretPostingUsed: Boolean(this.tmpBoardDetail.secretPostingUsed),
        memberPostingUsed: Boolean(this.tmpBoardDetail.memberPostingUsed),
        boardId: this.tmpBoardDetail.boardId?.toString(),
        used: this.tmpBoardDetail.used,
        categories: [],
        attachmentUsed: this.tmpBoardDetail.attachmentUsed,
      }
    };
    if (this.tmpBoardDetail.categories.length > 0 && this.tmpBoardDetail.categories[0].categoryName !== null && this.tmpBoardDetail.categories[0].categoryName.length > 0) {
      request.data.categories = this.tmpBoardDetail.categories.map(
        (category: BoardCategoryResponse): CategoriesName => {
          return {name: category.categoryName};
        }
      );
    }

    this.$api
      .postBoards(request)
      .then((): void => {
        alert(this.$t('BOARD_BOARD_COMPLETE_SAVE'));
        this.doChangeMall();
      })
      .catch((): void => {});
  }

  private doDeleteBoard(index: number): void {
    const request: DeleteBoardsRequest = {
      params: {
        boardNo: this.boards[index].boardNo.toString(),
        mallNo: this.mallNo
      }
    };
    this.$api
      .deleteBoards(request)
      .then((): void => {
        this.doChangeMall();
      })
      .catch((): void => {});
  }

  private doChangeBoardOrder(index: number, step: number): void {
    const reverseIndex = this.boards.length - index - 1;
    const request: PutBoardsRequest = {
      params: {
        boardNo: this.boards[index].boardNo.toString()
      },
      data: {
        newOrder: reverseIndex + step,
        mallNo: this.mallNo
      }
    };
    this.$api
      .putBoardsOrder(request)
      .then(() => {
        this.boardIndex = index - step;
        this.isOrder = true;
        this.doChangeMall();
      })
      .catch(() => {});
  }
  private doModifyBoardDetail(): void {
    const request: any = {
      params: {
        boardNo: this.boards[this.boardIndex].boardNo.toString()
      },
      data: {
        mallNo: this.mallNo,
        name: this.tmpBoardDetail.boardName.toString(),
        description: this.tmpBoardDetail.boardDescription?.toString(),
        replyUsed: JSON.parse(this.tmpBoardDetail.replyUsed),
        categoryUsed: JSON.parse(this.tmpBoardDetail.categoryUsed),
        thumbnailUsed: JSON.parse(this.tmpBoardDetail.thumbnailUsed),
        guestPostingUsed: JSON.parse(this.tmpBoardDetail.guestPostingUsed),
        secretPostingUsed: JSON.parse(this.tmpBoardDetail.secretPostingUsed),
        memberPostingUsed: JSON.parse(this.tmpBoardDetail.memberPostingUsed),
        boardId: this.tmpBoardDetail.boardId?.toString(),
        used: this.tmpBoardDetail.used,
        categories: []
      }
    };

    if (this.tmpBoardDetail.categories.length > 0 && this.tmpBoardDetail.categories[0].categoryName !== null && this.tmpBoardDetail.categories[0].categoryName.length > 0) {
      request.data.categories = this.tmpBoardDetail.categories.map(({ categoryNo: no, categoryName: name }) => ({ no: no > 0 ? no : null, name }));
    }
    this.$api.putBoardsDetail(request).then(() => {
      alert(this.$t('BOARD_BOARD_COMPLETE_SAVE'));
      this.doChangeMall();
    });
  }

  private async mounted() {
    await this.fetchMalls();
    if (this.$route.query.mallNo) {
      this.mallNo = Number(this.$route.query.mallNo);
    } else {
      this.mallNo = this.malls[0].mallNo;
    }
    await this.doChangeMall();
  }
}
